import { render } from "./BreedingMountModal.vue?vue&type=template&id=188d833a&scoped=true&ts=true"
import script from "./BreedingMountModal.vue?vue&type=script&lang=ts"
export * from "./BreedingMountModal.vue?vue&type=script&lang=ts"

import "./BreedingMountModal.vue?vue&type=style&index=0&id=188d833a&lang=scss&scoped=true"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188d833a"]])

export default __exports__